import { PageTitle } from '@/components/seo/page-title';
import { SettingsScreen } from '@/screens/settings/settings-screen';
import { SettingsItemData, SettingsToggleItemData } from '@/screens/settings/components/settings-item';
import { useUnitsControl } from '@/providers/units-provider';
import { useAuth } from '@/hooks/use-auth';
import { useRouter } from 'expo-router';
import React from 'react';

export default function SettingsRoute() {
  const router = useRouter();

  // Auth for sign out
  const { logout } = useAuth();

  // Units control from context
  const { units, toggleUnits } = useUnitsControl();

  // Setting sections data - now properly typed
  const accountSettings: SettingsItemData[] = [
    { icon: 'person-outline', title: 'Account Information', action: () => {}, disabled: true },
    { icon: 'lock-closed-outline', title: 'Privacy & Security', action: () => {}, disabled: true },
  ];

  const preferencesSettings: SettingsToggleItemData[] = [
    {
      icon: 'speedometer-outline',
      title: 'Use Metric Units',
      value: units === 'metric',
      onToggle: toggleUnits,
    },
  ];

  const supportSettings: SettingsItemData[] = [
    { icon: 'help-circle-outline', title: 'Help Center', action: () => {}, disabled: true },
    { icon: 'information-circle-outline', title: 'About', action: () => {}, disabled: true },
    { icon: 'document-text-outline', title: 'Terms of Service', action: () => router.push('/(root)/terms-of-service') },
    { icon: 'shield-checkmark-outline', title: 'Privacy Policy', action: () => router.push('/(root)/privacy-policy') },
  ];

  const handleSignOut = async () => {
    try {
      await logout();
    } catch (error) {
      if (__DEV__) {
        console.error('Sign out error:', error);
      }
    }
  };

  return (
    <>
      <PageTitle title="Settings" />
      <SettingsScreen
        accountSettings={accountSettings}
        preferencesSettings={preferencesSettings}
        supportSettings={supportSettings}
        onSignOut={handleSignOut}
      />
    </>
  );
}
